import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconModule } from '../icon/icon.module';

/** Optional leading icon beside the page title. */
export type PageSurfaceTitleIcon =
  | 'dashboard'
  | 'cpu-bolt'
  | 'users'
  | 'user'
  | 'clients'
  | 'chart'
  | 'clipboard'
  | 'workflow'
  | 'billing'
  | 'card'
  | 'bell'
  | 'clock'
  | 'lock'
  | 'globe'
  | 'file'
  | 'notes'
  | 'link'
  | 'settings'
  | 'server'
  | 'heart'
  | 'checks';

/** Tab item for {@link PageSurfaceHeaderComponent}. */
export interface PageSurfaceTab {
  key: string;
  label: string;
}

/**
 * Consistent page chrome: title row with optional pill tabs on the right, subtitle below.
 * Project optional actions with <ng-container ngProjectAs="[pageHeaderActions]">…</ng-container>.
 */
@Component({
  selector: 'app-page-surface-header',
  standalone: true,
  imports: [CommonModule, IconModule],
  templateUrl: './page-surface-header.component.html',
})
export class PageSurfaceHeaderComponent {
  @Input({ required: true }) title!: string;
  @Input() titleIcon?: PageSurfaceTitleIcon | null;
  @Input() subtitle = '';
  @Input() tabs: PageSurfaceTab[] = [];
  @Input() activeTabKey = '';
  /** Accessible name for the tablist when tabs are shown. */
  @Input() tablistLabel = '';
  /** Smaller bottom margin when stacked with adjacent meta (e.g. tenant id). */
  @Input() compact = false;

  @Output() activeTabKeyChange = new EventEmitter<string>();

  get ariaTablistLabel(): string {
    return this.tablistLabel || this.title;
  }

  trackTabKey(_index: number, tab: PageSurfaceTab): string {
    return tab.key;
  }

  selectTab(key: string): void {
    if (key !== this.activeTabKey) {
      this.activeTabKeyChange.emit(key);
    }
  }
}
